import React, { useState } from 'react';
import { Button } from 'components/button';
import { DateRange, ReportFormat } from 'services/reconciliationService';
import styled from 'styled-components';
import { IoDownloadOutline } from 'react-icons/io5';
import ColumnSelectionModal from './ColumnSelectionModal';

interface DownloadReconciliationReportProps {
  dateRange: DateRange;
  format?: ReportFormat;
  disabled?: boolean;
  onStart?: () => void;
  onComplete?: () => void;
  onError?: (error: Error) => void;
}

const DownloadReconciliationReport: React.FC<DownloadReconciliationReportProps> = ({
  dateRange,
  format = 'csv',
  disabled = false,
  onStart,
  onComplete,
  onError
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleButtonClick = () => {
    if (disabled) {
      return;
    }

    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <DownloadContainer
        title={`Download Reconciliation Report (${format.toUpperCase()})`}
      >
        <IconButton
          onClick={handleButtonClick}
          disabled={disabled}
          size="small"
          title={`Download Reconciliation Report (${format.toUpperCase()})`}
        >
          <IoDownloadOutline size={14} />
          <span style={{ marginLeft: '4px', fontSize: '12px' }}>Report</span>
        </IconButton>
      </DownloadContainer>

      <ColumnSelectionModal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        dateRange={dateRange}
        format={format}
        onStart={onStart}
        onComplete={onComplete}
        onError={onError}
      />
    </>
  );
};

const DownloadContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const IconButton = styled(Button)`
  min-width: 80px;
  width: auto;
  height: 32px;
  min-height: 32px;
  padding: 6px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  box-sizing: border-box;
  white-space: nowrap;
  flex-shrink: 0;
  
  @media (max-width: 1024px) {
    min-width: 70px;
    padding: 5px 8px;
    height: 30px;
    min-height: 30px;
    font-size: 11px;
  }
  
  @media (max-width: 768px) {
    min-width: 60px;
    padding: 4px 6px;
    height: 28px;
    min-height: 28px;
    font-size: 10px;
  }
  
  @media (max-width: 480px) {
    min-width: 50px;
    padding: 3px 6px;
    height: 26px;
    min-height: 26px;
    font-size: 9px;
  }
`;

export default DownloadReconciliationReport;
